import AppConstatnt from '../../../../../config/app.constants';

class PrintController {
    /*@ngInject*/
    constructor(Auth, $state, $location, ShipmentService, BagoutService, DateUtil, $translate, $q, Modal) {
        this.ShipmentService = ShipmentService;
        this.BagoutService = BagoutService;
        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.Modal = Modal;
    }

    $onInit() {
        let printData = undefined;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
            this.physicalCashCountData = printData.physicalCashCountData;
            this.branch = printData.branch
            this.isSupervisor = printData.isSupervisor;
            this.denomsForAccount = printData.denomsForAccount;
            this.print();
        }
    }

    print() {
        setTimeout(() => {
            window.print()
        }, 1500)
    }

    amountVariance(amount) {
        let num = Number(amount);
        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    isFloat(n) {
        return n % 1 !== 0;
    }
}
export default PrintController;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/physical_cash_count/print/print_physical_cash_count.controller.js